import UrlHash from '../lib/urlHash';

export default class PopupVariant {
  constructor($popup) {
    this.$popup = $popup;

    if (this.$popup) {
      this.id = this.$popup.id;
      this.$popup.__instance = this;
      this.$close = this.$popup.querySelector('.js-popup-close');

      this.bindEvents();

      if (UrlHash.has(this.id)) {
        this.show();
      }
    }
  }

  static init(selector) {
    return new PopupVariant(document.querySelector(selector));
  }

  static initAll(selector) {
    document.querySelectorAll(selector).forEach(($popup) => {
      new PopupVariant($popup);
    });
  }

  bindEvents() {
    this.$close.addEventListener('click', (event) => {
      event.preventDefault();

      this.hide();
    });

    this.$popup.addEventListener('click', (event) => {
      if (!event.target.closest('.js-popup-body')) {
        event.preventDefault();

        this.hide();
      }
    });

    document.body.addEventListener('keyup', (event) => {
      if (event.keyCode === 27 && this.isShown()) {
        event.preventDefault();
        this.hide();
      }
    });

    UrlHash.onChange(() => {
      const hasHash = UrlHash.has(this.id);
      const isShown = this.isShown();

      if (hasHash && !isShown) {
        this.show();
      } else if (!hasHash && isShown) {
        this.hide();
      }
    });
  }

  hide() {
    this.$popup.classList.remove('popup--open');
    document.body.classList.remove('is-cropped');
    UrlHash.remove(this.id);
    this.$popup.scrollTo(0, 0);
  }

  show() {
    this.$popup.classList.add('popup--open');
    document.body.classList.add('is-cropped');
    UrlHash.add(this.id);
  }

  isShown() {
    return this.$popup.classList.contains('popup--open');
  }
}
